import React, { useEffect, useRef, useState } from "react";

const NewsItem = ({ res }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const descriptionRef = useRef(null);

  useEffect(() => {
    if (descriptionRef.current) {
      // Check if the description height exceeds 185px
      if (descriptionRef.current.scrollHeight > 185) {
        setShowToggle(true);
      }
    }
  }, []);

  return (
    <>
      <div
        className={` ${isExpanded ? "" : "truncate"}`} id="news_itemss"
        ref={descriptionRef}
        dangerouslySetInnerHTML={{
          __html: res.short_description,
        }}
      ></div>
      {showToggle && (
        <button
          className="see-more-btn"
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering the onClick of the parent
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? "See Less" : "See More"}
        </button>
      )}
    </>
  );
};

export default NewsItem;
